import { render, staticRenderFns } from "./main-system.vue?vue&type=template&id=66efd5ea&scoped=true&"
import script from "./main-system.vue?vue&type=script&lang=js&"
export * from "./main-system.vue?vue&type=script&lang=js&"
import style0 from "./main-system.vue?vue&type=style&index=0&id=66efd5ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66efd5ea",
  null
  
)

export default component.exports